exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Map {\n  flex: 3;\n  background-color: #bbbbbb;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  left: 300px;\n  width: auto !important;\n  height: auto !important;\n}\n\n@media (max-width: 992px) {\n  .Map {\n    left: 0;\n    top: 44px;\n  }\n}\n\n.Map__info-title {\n  width: 100%;\n  color: #0256B8;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.Map__info-content span {\n  font-weight: 500;\n}\n\n", ""]);

// exports
